import React from 'react'
import { LoginForm } from 'components/index'
import styles from './Login.module.scss'
import chuLogo from 'assets/img/chu.svg'

function Login() {
  return (
    <div className={styles.wrapper}>

      {/* ── Left branding panel (desktop only) ── */}
      <div className={styles.brand}>
        <div className={styles.brand__inner}>
          <div className={styles.brand__logo}>
            <img src={chuLogo} alt="Чуйский Университет" />
          </div>
          <h1 className={styles.brand__title}>Чуйский Университет</h1>
          <p className={styles.brand__subtitle}>
            Корпоративная информационная система управления университетом
          </p>
          <div className={styles.brand__divider} />
          <ul className={styles.brand__features}>
            <li className={styles.brand__feature}>
              <span className={styles.brand__dot} />
              <span>Управление кадрами и академическим процессом</span>
            </li>
            <li className={styles.brand__feature}>
              <span className={styles.brand__dot} />
              <span>Аналитика, отчётность и документооборот</span>
            </li>
            <li className={styles.brand__feature}>
              <span className={styles.brand__dot} />
              <span>Внутренние коммуникации и управление задачами</span>
            </li>
          </ul>
        </div>
        <div className={styles.brand__footer}>
          © {new Date().getFullYear()} Чуйский Университет. Все права защищены.
        </div>
      </div>

      {/* ── Right form panel ── */}
      <div className={styles.form__panel}>
        <div className={styles.form__card}>
          <LoginForm />
        </div>
      </div>

    </div>
  )
}

export default Login
